import {configure} from 'mobx'
import React from 'react'

import {AntProvider} from '@/src/config/ant'
import StyleRegistry from '@/src/providers/style-registry'

import {Theme} from './styled-theme'
import {PageProvider} from '@/src/providers/page-provider'

export interface IProps {
  children: React.ReactNode
}

configure({
  enforceActions: 'always',
  useProxies: 'always',
})

const Providers = ({children}: IProps) => {
  return (
    <StyleRegistry>
      <AntProvider>
        <Theme>
          <PageProvider>{children}</PageProvider>
        </Theme>
      </AntProvider>
    </StyleRegistry>
  )
}

export default Providers
